import { Stack, Tooltip, UnstyledButton, Avatar, Divider, Image } from '@mantine/core';
import { IconLogout, IconMessageChatbot } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '../auth/useAuth';
import { NAV_SECTIONS } from '../constants/pipeline';

function getInitials(name) {
  if (!name) return 'U';
  return name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() || '').join('') || 'U';
}

export default function DoubleNavbar({ onNavClick }) {
  const { user, logout } = useAuth0();
  const location = useLocation();

  return (
    <Stack
      h="100%"
      w={80}
      bg="aviary.8"
      align="center"
      justify="space-between"
      py="md"
      gap={0}
    >
      <Stack align="center" gap="lg">
        <Image src="/logo_small.png" w={72} h={72} fit="contain" style={{ flexShrink: 0 }} />

        <Divider color="aviary.7" w={40} />

        {NAV_SECTIONS.map((item) => {
          const active = location.pathname.startsWith(item.href) ||
            (item.href === '/home' && location.pathname === '/');
          const Icon = item.icon;
          return (
            <Tooltip key={item.href} label={item.label} position="right" withArrow>
              <UnstyledButton
                component={Link}
                to={item.href}
                onClick={onNavClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 44,
                  height: 44,
                  borderRadius: 8,
                  backgroundColor: active ? 'var(--mantine-color-aviary-6)' : 'transparent',
                  color: '#EBE2D3',
                  transition: 'background-color 120ms ease',
                }}
              >
                <Icon size={22} />
              </UnstyledButton>
            </Tooltip>
          );
        })}
      </Stack>

      <Stack align="center" gap="sm">
        <Divider color="aviary.7" w={40} />

        <Tooltip
          label={`${user?.name || 'User'}\n${user?.email || ''}`}
          position="right"
          withArrow
          multiline
          maw={200}
        >
          <Avatar radius="xl" size="sm" color="aviary" style={{ cursor: 'default' }}>
            {getInitials(user?.name)}
          </Avatar>
        </Tooltip>

        <Tooltip label="Aviary v2 (beta)" position="right" withArrow>
          <UnstyledButton
            component={Link}
            to="/v2"
            onClick={onNavClick}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 44,
              height: 44,
              borderRadius: 8,
              backgroundColor: location.pathname.startsWith('/v2') ? 'var(--mantine-color-orange-8)' : 'transparent',
              color: 'var(--mantine-color-orange-4)',
              transition: 'background-color 120ms ease',
            }}
          >
            <IconMessageChatbot size={22} />
          </UnstyledButton>
        </Tooltip>

        <Tooltip label="Logout" position="right" withArrow>
          <UnstyledButton
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 44,
              height: 44,
              borderRadius: 8,
              color: 'var(--mantine-color-aviary-3)',
              transition: 'background-color 120ms ease',
            }}
          >
            <IconLogout size={20} />
          </UnstyledButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}
